<template>
  <div>
    <multiselect
      data-test-id="advertiser-dropdown"
      v-model="selection"
      :options="advertisers"
      :multiple="false"
      track-by="id"
      label="label"
      :placeholder="placeholder"
      :close-on-select="true"
      :searchable="true"
      :disabled="disabled"
      @input="inputValue($event)"
    >
    </multiselect>
  </div>
</template>

<script>
    import Multiselect from 'vue-multiselect'
    import store from './store.js'
    import { mapActions } from 'vuex'
    import isEmpty from 'lodash/isEmpty'

    export default {
        name: 'AdvertiserSelect',

        store,

        props: [],

        data() {
            return {
                selection: null,
            }
        },

        computed: {
            advertisers() {
                return this.$store.getters.advertisers.map(item => {
                    return {
                        ...item,
                        label: `${item.name} (${item.id})`
                    }
                })
            },
            placeholder() {
                return isEmpty(this.advertisers) ? 'Loading...' : 'Select Advertiser'
            },
            disabled() {
                return isEmpty(this.advertisers)
            }
        },

        methods: {
            ...mapActions([
                'fetchAdvertisers',
                'fetchAdvertiser'
            ]),
            inputValue(advertiser) {
                if (isEmpty(advertiser)) {
                    return
                }

                this.fetchAdvertiser({ baseUrl: window.Portal.baseUrl, id: advertiser.id })
                this.$emit('input', advertiser)
            }
        },

        mounted() {
            this.fetchAdvertisers({ baseUrl: window.Portal.baseUrl })
        },

        components: {
            Multiselect
        }
    }
</script>
